import { AxiosRequestConfig } from "axios";

import { Pair } from "@/app/trade/types";

import { axiosInstance } from "../api/axiosConfig";

export const getAvailablePairs = async (options: AxiosRequestConfig) => {
  const { data } = await axiosInstance.get("trade-engine/symbols", options);
  const cleanData = data.data.filter(
    (e: Pair) => e.quote_asset_id != null && e.volume !== 0,
  );

  let _pairs: string[] = [];

  for (var i = 0; i < cleanData.length; i++) {
    if (!_pairs.includes(cleanData[i].base_asset) && cleanData[i].base_asset) {
      _pairs.push(cleanData[i].base_asset);
    }
  }

  return { _pairs, assets: cleanData };
};

export const getAvailableOfBaseAsset = async (
  coin: string,
  options: AxiosRequestConfig,
) => {
  return await axiosInstance.get(`trade-engine/assets/${coin}`, options);
};

export const createTrade = async (options: AxiosRequestConfig) => {
  return axiosInstance
    .post("trade-engine/order", options.data, options)
  // .catch((reason: AxiosError) => {
  //   const response: AxiosResponse | undefined = reason.response;
  //   if (response?.data) {
  //     const errors: string[] = [];
  //     if (
  //       response?.data?.trade_engine_response?.detail?.validation_errors &&
  //       response?.data?.trade_engine_response?.detail?.list
  //     ) {
  //       errors.push(...response.data.trade_engine_response.detail.list);
  //     } else if (
  //       typeof response?.data?.trade_engine_response?.detail === "string"
  //     ) {
  //       errors.push(response?.data?.trade_engine_response?.detail);
  //     } else if (response?.data?.trade_engine_response?.detail?.entry) {
  //       errors.push(...response.data.trade_engine_response.detail.list);
  //     } else {
  //       errors.push("Something went wrong while creating trade");
  //     }
  //     response.data = { errors };
  //   }
  //   throw new AxiosError(
  //     "Something went wrong while creating trade",
  //     reason.code,
  //     reason.config,
  //     reason.request,
  //     response,
  //   );
  // });
};

export const getPaperPairs = async (search?: string) => {
  return await axiosInstance.get(`/paper-account/symbols`, {
    params: {
      search,
    },
  });
};

export const getPaperDatePrice = async (
  from: string,
  date: string,
  to: string,
) => {
  return await axiosInstance.get<any>(`/info/price`, {
    params: {
      from_asset: from,
      date,
      to_asset: to,
    },
  });
};

export const createPaperTransaction = async (
  providerId: any,
  {
    symbol_name,
    asset_name,
    base_name,
    settled_at,
    side,
    amount,
    price,
    affect,
    fees,
  }: {
    symbol_name: string;
    asset_name: string;
    base_name: string;
    settled_at: string;
    side: string;
    amount: string;
    price: string;
    affect: boolean;
    fees: string;
  },
) => {
  return await axiosInstance.post<any>(
    `/paper-account/transaction`,
    {
      symbol_name,
      asset_name,
      base_name,
      settled_at,
      side,
      amount,
      price,
      fee_amount: fees,
      fee_currency: side === "BUY" ? asset_name : base_name,
      notes: "paper",
      change_other_assets_balance: affect,
    },
    {
      params: {
        exchange_key_id: providerId,
      },
    },
  );
};

export const updatePaperTransaction = async (
  id: any,
  {
    symbol_name,
    asset_name,
    base_name,
    settled_at,
    side,
    amount,
    price,
    affect,
    fees,
  }: {
    symbol_name: string;
    asset_name: string;
    base_name: string;
    settled_at: string;
    side: string;
    amount: string;
    price: string;
    affect: boolean;
    fees: string;
  },
) => {
  return await axiosInstance.put<any>(
    `/paper-account/transaction`,
    {
      symbol_name,
      asset_name,
      base_name,
      settled_at,
      side,
      amount,
      price,
      fee_amount: fees,
      fee_currency: side === "BUY" ? asset_name : base_name,
      notes: "paper",
      change_other_assets_balance: affect,
    },
    {
      params: {
        transaction_id: id,
      },
    },
  );
};

export const deletePaperTransaction = async (id: any) => {
  return await axiosInstance.delete<any>(`/paper-account/transaction`, {
    params: {
      transaction_id: id,
    },
  });
};
